import type { ReadonlyDeep } from 'type-fest';

import type { FolderStateForm_FolderArchiveInfo } from '../fragments/folder-archive-info.fragment';

export function isFolderArchiveInfoComplete(
  draft: ReadonlyDeep<Partial<FolderStateForm_FolderArchiveInfo>>,
): boolean {
  const isDateOrderValid =
    !draft.startDateForAnalytics ||
    !draft.endDateForAnalytics ||
    draft.startDateForAnalytics <= draft.endDateForAnalytics;

  return (
    !!draft.startDateForAnalytics &&
    !!draft.endDateForAnalytics &&
    isDateOrderValid
  );
}
